import {
  shareYachtsList,
  yachtsOrderList,
  teachOrderList,
  payContinue,
} from '@/api';
import i18n from '@/lang';
import dayjs from 'dayjs';
import { success, fail, failMsg } from '@/libs/utils';
import { Loading } from 'element-ui';

const state = {
  shareYachtList: [],
  yachtsOrder: {},
  yachtsOrderList: [],
  yachtsOrderQ: {},
  yachtsOrderListQ: [],
  teachOrder: {
    records: [],
    pages: 0,
    current: 0,
  },
  teachOrderList: [],
};

const actions = {
  // 获取散拼游艇
  async getShareList({ commit }, context) {
    Loading.service({
      background: 'rgba(0, 0, 0, 0.7)',
    });
    try {
      let data = await shareYachtsList({ rentDate: context });
      // 遍历添加timeType时间段参数，判断属于哪个时间段
      // 清晨0-5.59  上午6-11.59 下午12-16.59 傍晚17-19.59 深夜20-23.59
      // 对返回的时间做分段处理
      if (data.data) {
        data.data.forEach((item) => {
          item.timeType = '';
          let date = item.rentDate + ' ' + item.startTime;
          let date2 = item.rentDate + ' ' + item.endTime;
          let morning = item.rentDate + ' ' + '05:59:59';
          let riser = item.rentDate + ' ' + '11:59:59';
          let afternoon = item.rentDate + ' ' + '16:59:59';
          let sunset = item.rentDate + ' ' + '19:59:59';
          let night = item.rentDate + ' ' + '23:59:59';

          if (dayjs(date).isBefore(dayjs(morning))) {
            item.timeType = 0;
          } else if (dayjs(date).isBefore(dayjs(riser))) {
            item.timeType = 1;
          } else if (dayjs(date).isBefore(dayjs(afternoon))) {
            item.timeType = 2;
          } else if (dayjs(date).isBefore(dayjs(sunset))) {
            item.timeType = 3;
          } else if (dayjs(date).isBefore(dayjs(night))) {
            item.timeType = 4;
          }

          if (dayjs(date2).isBefore(dayjs(morning))) {
            item.timeType2 = 0;
          } else if (dayjs(date2).isBefore(dayjs(riser))) {
            item.timeType2 = 1;
          } else if (dayjs(date2).isBefore(dayjs(afternoon))) {
            item.timeType2 = 2;
          } else if (dayjs(date2).isBefore(dayjs(sunset))) {
            item.timeType2 = 3;
          } else if (dayjs(date2).isBefore(dayjs(night))) {
            item.timeType2 = 4;
          }
        });
        setTimeout(() => {
          Loading.service().close();
        }, 300);
        commit('GETSHARELIST', data.data);
      } else {
        setTimeout(() => {
          Loading.service().close();
        }, 300);
      }
    } catch (error) {
      setTimeout(() => {
        Loading.service().close();
      }, 300);
      failMsg(error);
    }
  },
  // 游艇订单列表-非快速
  async getYachtsOrderList({ commit }, context) {
    Loading.service({
      background: 'rgba(0, 0, 0, 0.7)',
    });
    try {
      let data = await yachtsOrderList(context);
      // 对参数进行判断处理
      if (data.data) {
        data.data.records.forEach((item) => {
          if (i18n.locale === 'chinese') {
            item.orderStatusName = item.orderStatus.split('-')[0];
            item.paymentStatusName = item.paymentStatus.split('-')[0];
            if (item.rentType === 2) {
              item.takeOrderName = '超级游艇';
            } else {
              if (item.takeOrderType === 1) {
                item.takeOrderName = '散拼游艇';
              } else {
                item.takeOrderName = '整租游艇';
              }
            }
          } else if (i18n.locale === 'english') {
            item.orderStatusName = item.orderStatus.split('-')[1];
            item.paymentStatusName = item.paymentStatus.split('-')[1];
            if (item.rentType === 2) {
              item.takeOrderName = 'SUPER YACHT';
            } else {
              if (item.takeOrderType === 1) {
                item.takeOrderName = 'YACHT TOURS';
              } else {
                item.takeOrderName = 'YACHT CHARTER';
              }
            }
          }
        });
        setTimeout(() => {
          Loading.service().close();
        }, 300);
        commit('GETYACHTSORDERLIST', data.data);
      } else {
        setTimeout(() => {
          Loading.service().close();
        }, 300);
      }
    } catch (error) {
      setTimeout(() => {
        Loading.service().close();
      }, 300);
      failMsg(error);
    }
  },
  // 游艇订单列表-快速下单
  async getYachtsOrderListQ({ commit }, context) {
    Loading.service({
      background: 'rgba(0, 0, 0, 0.7)',
    });
    try {
      let data = await yachtsOrderList(context);
      // console.log(data)
      // 对参数进行判断处理
      if (data.data) {
        data.data.records.forEach((item) => {
          if (i18n.locale === 'chinese') {
            item.orderStatusName = item.orderStatus.split('-')[0];
            item.paymentStatusName = item.paymentStatus.split('-')[0];
            if (item.rentType === 2) {
              item.takeOrderName = '超级游艇';
            } else {
              if (item.takeOrderType === 1) {
                item.takeOrderName = '散拼游艇';
              } else {
                item.takeOrderName = '整租游艇';
              }
            }
          } else if (i18n.locale === 'english') {
            item.orderStatusName = item.orderStatus.split('-')[1];
            item.paymentStatusName = item.paymentStatus.split('-')[1];
            if (item.rentType === 2) {
              item.takeOrderName = 'SUPER YACHT';
            } else {
              if (item.takeOrderType === 1) {
                item.takeOrderName = 'YACHT TOURS';
              } else {
                item.takeOrderName = 'YACHT CHARTER';
              }
            }
          }
        });
        setTimeout(() => {
          Loading.service().close();
        }, 300);
        commit('GETYACHTSORDERLISTQ', data.data);
      } else {
        setTimeout(() => {
          Loading.service().close();
        }, 300);
      }
    } catch (error) {
      setTimeout(() => {
        Loading.service().close();
      }, 300);
      failMsg(error);
    }
  },
  // 教学订单列表
  async getTeachOrderList({ commit }, context) {
    Loading.service({
      background: 'rgba(0, 0, 0, 0.7)',
    });
    try {
      const data = await teachOrderList(context);
      if (data.data) {
        data.data.records.forEach((item) => {
          setTimeout(() => {
            Loading.service().close();
          }, 300);
          if (i18n.locale === 'chinese') {
            item.paymentStatusName = item.paymentStatus.split('-')[0];
          } else if (i18n.locale === 'english') {
            item.paymentStatusName = item.paymentStatus.split('-')[1];
          }
        });
        commit('GETTEACHORDERLIST', data.data);
      } else {
        setTimeout(() => {
          Loading.service().close();
        }, 300);
      }
    } catch (error) {
      setTimeout(() => {
        Loading.service().close();
      }, 300);
      failMsg(error);
    }
  },
  async payOrder({ commit }, context) {
    Loading.service({
      background: 'rgba(0, 0, 0, 0.7)',
    });
    try {
      const data = await payContinue(context);
      location.href = data.data;
    } catch (error) {
      failMsg(error);
      setTimeout(() => {
        location.reload();
      }, 1500);
    }
  },
};

const mutations = {
  // 获取散拼游艇
  GETSHARELIST(state, data) {
    state.shareYachtList = data;
  },
  // 游艇订单列表-非快速
  GETYACHTSORDERLIST(state, data) {
    state.yachtsOrder = data;
    state.yachtsOrderList = state.yachtsOrderList.concat(
      state.yachtsOrder.records
    );
  },
  // 游艇订单列表-快速
  GETYACHTSORDERLISTQ(state, data) {
    state.yachtsOrderQ = data;
    state.yachtsOrderListQ = state.yachtsOrderListQ.concat(
      state.yachtsOrderQ.records
    );
  },
  // 清空游艇订单列表-非快速
  RESETYACHTSORDERLIST(state) {
    state.yachtsOrder = {};
    state.yachtsOrderList = [];
  },
  // 清空游艇订单列表-快速
  RESETYACHTSORDERLISTQ(state) {
    state.yachtsOrderQ = {};
    state.yachtsOrderListQ = [];
  },
  // 教学订单列表
  GETTEACHORDERLIST(state, data) {
    state.teachOrder = data;
    state.teachOrderList = state.teachOrderList.concat(
      state.teachOrder.records
    );
  },
  // 清空教学订单列表
  RESETTEACHORDERLIST(state) {
    state.teachOrder = {};
    state.teachOrderList = [];
  },
};

export default {
  state,
  actions,
  mutations,
};
